<template>
    <div class="paySuccess main center">
        <Icon type="md-checkmark-circle-outline" size="60" color="green"/>
        <h2 class="paySuccess-title">支付凭证已上传</h2>
        <p class="paySuccess-subtitle">确认收到款项后，会向手机号{{phone}}发送短信。信息可能存在延迟，敬请谅解。</p>
        <Button type="primary" @click="back">返回我的订单</Button>
    </div>
</template>
<script>
export default {
    data(){
        return {
            id:this.$route.params.id||'',
            phone:this.$route.query.phone,
            type:this.$route.query.type||''
        }
    },
    methods: {
        back() {
            location.href=`/haierProduct.html#/my/order-detail/${this.id}`+(this.type?`/${this.type}`:'')
        }
    },
}
</script>
<style scoped lang="less">
.paySuccess{
    padding:50px 20px;
    &-title{
        margin-top: 20px;
    }
    &-subtitle{
        color: red;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/Success.vue